import { BarChart } from "@repo/core/components/chart/ReportCharts/BarChart";

export const ReportCharts = {
  Bar: BarChart
};
